/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SecReviewSREntityResultDataResponseHeadersHeaders } from './SecReviewSREntityResultDataResponseHeadersHeaders';
import {
    SecReviewSREntityResultDataResponseHeadersHeadersFromJSON,
    SecReviewSREntityResultDataResponseHeadersHeadersFromJSONTyped,
    SecReviewSREntityResultDataResponseHeadersHeadersToJSON,
} from './SecReviewSREntityResultDataResponseHeadersHeaders';

/**
 * 
 * @export
 * @interface SecReviewSREntityResultDataResponseHeaders
 */
export interface SecReviewSREntityResultDataResponseHeaders {
    /**
     * 
     * @type {SecReviewSREntityResultDataResponseHeadersHeaders}
     * @memberof SecReviewSREntityResultDataResponseHeaders
     */
    headers?: SecReviewSREntityResultDataResponseHeadersHeaders;
}

/**
 * Check if a given object implements the SecReviewSREntityResultDataResponseHeaders interface.
 */
export function instanceOfSecReviewSREntityResultDataResponseHeaders(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SecReviewSREntityResultDataResponseHeadersFromJSON(json: any): SecReviewSREntityResultDataResponseHeaders {
    return SecReviewSREntityResultDataResponseHeadersFromJSONTyped(json, false);
}

export function SecReviewSREntityResultDataResponseHeadersFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecReviewSREntityResultDataResponseHeaders {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'headers': !exists(json, 'headers') ? undefined : SecReviewSREntityResultDataResponseHeadersHeadersFromJSON(json['headers']),
    };
}

export function SecReviewSREntityResultDataResponseHeadersToJSON(value?: SecReviewSREntityResultDataResponseHeaders | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'headers': SecReviewSREntityResultDataResponseHeadersHeadersToJSON(value.headers),
    };
}

